"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TccProxy: ()=>TccProxy
});
const stale_while_revalidate_js_namespaceObject = require("../strategy-fetch/stale-while-revalidate.js");
const network_first_js_namespaceObject = require("../strategy-fetch/network-first.js");
const external_eventemitter3_namespaceObject = require("eventemitter3");
const get_cache_key_js_namespaceObject = require("./helpers/get-cache-key.js");
const deep_equal_js_namespaceObject = require("./utils/deep-equal.js");
const get_tcc_proxy_request_js_namespaceObject = require("./helpers/get-tcc-proxy-request.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function tcc_proxy_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else tcc_proxy_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const initPromiseCache = ()=>{
    try {
        if (!self.tccProxyCloudPromiseCache) self.tccProxyCloudPromiseCache = {};
        return self.tccProxyCloudPromiseCache;
    } catch (error) {
        return {};
    }
};
const PROMISE_CACHE = initPromiseCache();
class TccProxy extends external_eventemitter3_namespaceObject.EventEmitter {
    get responseRef() {
        return this.currentResponse;
    }
    get channelName() {
        return `${TccProxy.TCC_PROXY_CHANNEL_NAME_PREFIX}${this.cacheKey}`;
    }
    getLoadPromise() {
        let { requestInit } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const { isPreview, isTest, namespace, key, fetchStrategy, useFallbackHostname } = this.props;
        var _this_props_hostname;
        const hostname = null != (_this_props_hostname = this.props.hostname) ? _this_props_hostname : 'undefined' != typeof location ? location.hostname : void 0;
        if ('string' != typeof hostname) throw new Error(`[tcc-proxy:${this.cacheKey}] cannot get hostname: ${hostname}`);
        const request = (0, get_tcc_proxy_request_js_namespaceObject.getTCCProxyRequest)({
            namespace,
            key,
            isTest,
            isPreview,
            hostname,
            requestInit
        });
        const strategyFetch = 'networkFirst' === fetchStrategy ? network_first_js_namespaceObject.networkFirstFetch : stale_while_revalidate_js_namespaceObject.staleWhileRevalidateFetch;
        const promise = isPreview ? fetch(request) : strategyFetch({
            request,
            cacheName: 'cloud-tcc-proxy',
            attachFetchStrategyToResponseHeader: this.props.attachFetchStrategyToResponseHeader
        }).catch((e)=>{
            if (useFallbackHostname) {
                const fallbackRequest = (0, get_tcc_proxy_request_js_namespaceObject.getTCCProxyRequest)({
                    namespace,
                    key,
                    isTest,
                    isPreview,
                    hostname,
                    requestInit,
                    useFallbackHostname: true
                });
                return fetch(fallbackRequest);
            }
            throw e;
        });
        return promise.then((res)=>{
            this.currentResponse = res;
            return res.json();
        }).catch((error)=>{
            if (error instanceof Error) console.error(`[tcc-proxy:${this.cacheKey}] fetch config error: ${error.message}`);
        });
    }
    async getConfigSafe(data) {
        try {
            const result = await data;
            return result || this.props.defaultValue;
        } catch (error) {
            console.error(error);
            return this.props.defaultValue;
        }
    }
    async getConfig() {
        return this.getConfigSafe(this.data);
    }
    async reloadConfig() {
        const maybeNewValuePromise = this.getLoadPromise({
            requestInit: {
                cache: 'no-cache'
            }
        }).then((data)=>{
            if ('function' == typeof this.props.validator && !this.props.validator(data)) throw new Error(`Validate data failed when reload config. The data is ${data}. The namespace is ${this.props.namespace}. The key is ${this.props.key}. The hostname is ${this.props.hostname}`);
            return data;
        }).catch((error)=>{
            if (error instanceof Error) console.error(`[tcc-proxy:${this.cacheKey}] ${error.message}`);
        });
        const maybeNewConfigPromise = this.getConfigSafe(maybeNewValuePromise);
        const [previousConfig, currentConfig] = await Promise.all([
            this.getConfig(),
            maybeNewConfigPromise
        ]);
        PROMISE_CACHE[this.cacheKey] = maybeNewValuePromise;
        this.data = maybeNewValuePromise;
        const isEqual = this.props.isEqual || deep_equal_js_namespaceObject.deepEqual;
        if (!isEqual(previousConfig, currentConfig)) {
            var _this_channel;
            const payload = {
                previousConfig,
                currentConfig,
                source: 'reloadTrigger'
            };
            this.emit('configChange', payload);
            null == (_this_channel = this.channel) || _this_channel.postMessage({
                type: 'configChange',
                payload
            });
        }
    }
    listenToChannel() {
        let { onListenSuccess } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const listener = (event)=>{
            var _event_data, _event_data_payload, _event_data1;
            if ('object' == typeof event.data && null !== event.data && (null == (_event_data = event.data) ? void 0 : _event_data.type) === 'configChange' && (null == (_event_data1 = event.data) ? void 0 : null == (_event_data_payload = _event_data1.payload) ? void 0 : _event_data_payload.currentConfig)) {
                const newValuePromise = Promise.resolve(event.data.payload.currentConfig);
                PROMISE_CACHE[this.cacheKey] = newValuePromise;
                this.data = newValuePromise;
                this.emit('configChange', _object_spread_props(_object_spread({}, event.data.payload), {
                    source: 'channel'
                }));
            }
        };
        if (this.channel) {
            this.channel.addEventListener('message', listener);
            null == onListenSuccess || onListenSuccess(this.channel);
        }
        return ()=>{
            var _this_channel;
            null == (_this_channel = this.channel) || _this_channel.removeEventListener('message', listener);
        };
    }
    async broadcastConfig(config) {
        var _this_channel;
        const currentConfig = null != config ? config : await this.getConfig();
        const payload = {
            previousConfig: currentConfig,
            currentConfig,
            source: 'manualBroadcast'
        };
        this.emit('configChange', payload);
        null == (_this_channel = this.channel) || _this_channel.postMessage({
            type: 'configChange',
            payload
        });
    }
    constructor(props){
        super(), _define_property(this, "data", void 0), _define_property(this, "props", void 0), _define_property(this, "cacheKey", void 0), _define_property(this, "channel", void 0), _define_property(this, "currentResponse", void 0);
        this.props = props;
        this.cacheKey = (0, get_cache_key_js_namespaceObject.getCacheKey)(props);
        if (!PROMISE_CACHE[this.cacheKey]) PROMISE_CACHE[this.cacheKey] = this.getLoadPromise();
        const promise = PROMISE_CACHE[this.cacheKey];
        if (promise) this.data = promise.then((data)=>{
            if ('function' == typeof this.props.validator && !this.props.validator(data)) throw new Error(`Validate data failed. The data is ${data}. The namespace is ${this.props.namespace}. The key is ${this.props.key}. The hostname is ${this.props.hostname}`);
            return data;
        }).catch((error)=>{
            if (error instanceof Error) console.error(`[tcc-proxy:${this.cacheKey}] ${error.message}`);
        });
        else this.data = Promise.resolve(void 0);
        this.channel = 'function' == typeof BroadcastChannel ? new BroadcastChannel(this.channelName) : null;
    }
}
_define_property(TccProxy, "TCC_PROXY_CHANNEL_NAME_PREFIX", '__TCC_PROXY_BROADCAST_CHANNEL__');
exports.TccProxy = __webpack_exports__.TccProxy;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TccProxy"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
